import { HeaderContentFooter } from '../../../components/layout/HeaderContentFooter';
import { FactoryInstance } from '../../../factory';
import { withRoutes } from '../hocs/withRoutes';
import { LayoutWithRoutes } from './Routes';
export * from './Routes';
export var HeaderRoutesFooterLayout = withRoutes(HeaderContentFooter);
FactoryInstance.registerComponent(HeaderRoutesFooterLayout, 'HeaderRoutesFooterLayout');
FactoryInstance.registerComponent(LayoutWithRoutes);
